const president = {
  'president.hero.home': 'ホーム',
  'president.hero.parent': 'アカデミーについて',
  'president.hero.current': '学長挨拶',
  'president.hero.title': '学長挨拶',
  'president.hero.titleEn': 'MESSAGE FROM THE PRESIDENT',
  'president.hero.lead':
    '一般社団法人全日本執事協会 三代目頭取・執事ベルより、日本執事アカデミーを志すみなさまへ。',
  'president.hero.imgAlt': '一般社団法人全日本執事協会 三代目頭取・執事ベルの正装ポートレート',

  'president.greeting.label': 'GREETING',
  'president.greeting.title': '学長からのご挨拶',
  'president.greeting.subtitleEn': 'A message from the president',
  'president.greeting.para1':
    'このページをご覧いただき、ありがとうございます。日本執事アカデミー学長であり、一般社団法人全日本執事協会 三代目頭取を務める執事ベルです。執事という仕事に関心を持ってくださったみなさまに、まずは心より御礼を申し上げます。',
  'president.greeting.para2':
    '執事の仕事は、華やかなおもてなしの表側だけでは語れません。相手の望みを言葉にされる前に察し、静かに寄り添う——その規律と所作を積み重ねてこそ、本物のおもてなしが生まれます。私は長年、YouTube「執事ベル」などを通じて執事文化を社会に伝える活動を続けてきましたが、その根底にあるのは、執事という仕事を、明確な基準のもとで評価される専門職として社会に位置づけたいという想いです。',
  'president.greeting.para3':
    '日本執事アカデミーは、一般社団法人全日本執事協会が運営する教育部門として設立されました。協会が担う執事の育成・認定資格の発行・法人研修という活動を、体系立てたカリキュラムとして一つの学びの場に結晶させたのが、このアカデミーです。エッセンシャルからマスターまでの段階的な学びを通じて、執事としての規律と所作を、誰もが確かな基準のもとで身につけられる環境を用意しました。',
  'president.greeting.para5':
    '協会が生まれたのは1890年（明治23年）のことです。以来、執事は世に出ることなく黒子に徹し、確かなご紹介によってのみお客様とお会いするという流儀が受け継がれてきました。その矜持は長く協会の背骨でしたが、同時に、執事を必要とする方がご自身では出会えないという時代でもありました。三代目として私が掲げたのは「執事は選ぶ時代へ」という一語です。在籍する執事の名簿を公開し、料金を明らかにし、ご紹介がなくともご依頼いただける窓口を設ける。そして2025年2月、一般社団法人として体制を整えました。',
  'president.greeting.para6':
    'この決断をめぐって、会の中で意見が分かれたことも事実です。議論は尽くされ、道を分かった者もおります。それでも私がこの道を選んだのは、執事という仕事を次の百年へ渡すためでした。守ろうとしたものは、どちらの側も同じです。その敬意を胸に、私たちは新しい執事協会の第一歩を踏み出しています。',
  'president.greeting.para4':
    '執事という仕事に興味を持たれた方の中には、伝統的な世界に少し距離を感じている方もいらっしゃるかもしれません。しかし、この仕事の本質は、相手を思う気持ちと、それを形にする所作の積み重ねにあります。学ぶ意欲があれば、誰にでも開かれた道です。日本執事アカデミーで、共に執事という仕事の奥深さを学んでいけることを、楽しみにしています。',

  'president.signature.name': '執事ベル',
  'president.signature.title': '日本執事アカデミー 学長 / 全日本執事協会 三代目頭取（一般社団法人全日本執事協会 代表理事）',

  'president.links.label': 'MORE ABOUT BUTLER BELL',
  'president.links.title': '執事ベルについてもっと知る',
  'president.links.subtitleEn': 'Learn more about Butler Bell',
  'president.links.body':
    '執事ベルの活動や情報発信の詳細は、日本執事アカデミー内の紹介ページと、執事ベルの公式サイトでご覧いただけます。',
  'president.links.internalCta': '執事ベルの紹介ページを見る',
  'president.links.externalCta': '執事ベル公式サイトを見る',
  'president.links.externalUrl': 'butlerbell.jp',
  'president.links.associationCta': '運営母体・全日本執事協会について',

  'president.backToAbout': 'アカデミーについてのページへ戻る',
  'president.lastUpdated': '最終更新: 2026年7月5日',
};

export default president;
